module.exports = __webpack_public_path__ + "img/destination_ruaha3.b6fca137.jpg";